/* eslint-disable max-classes-per-file */
export interface RequestRewardRegisterCheckOtpInterface {
  ref_code: string;
  otp_code: string;
  prefix_phone: string;
  phone_number: string;
}

export class ResponseStepsRewardRegister {
  registerStep: boolean;

  checkOtpStep: boolean;

  surveyStep: boolean;

  prizeStep: boolean;

  notifyStep: boolean;

  constructor(data: any) {
    this.registerStep = data?.registerStep || false;
    this.checkOtpStep = data?.checkOtpStep || false;
    this.surveyStep = data?.surveyStep || false;
    this.prizeStep = data?.prizeStep || false;
    this.notifyStep = data?.notifyStep || false;
  }
}
export class ResponseRewardRegisterCheckOtp {
  status: boolean;

  message: string;

  token: string;

  data: {
    steps: ResponseStepsRewardRegister;
  };

  constructor(data: any) {
    this.status = data?.status || false;
    this.message = data?.message || "";
    this.token = data?.token || "";
    this.data = {
      steps: new ResponseStepsRewardRegister(data?.data?.steps),
    };
  }
}
